import script from "./learnmore.vue?vue&type=script&setup=true&lang=js"
export * from "./learnmore.vue?vue&type=script&setup=true&lang=js"

import "./learnmore.vue?vue&type=style&index=0&id=ce5c9232&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce5c9232"]])

export default __exports__